import React, { useState } from "react";
import Modal from "./Modal";

/**
 * Подтверждение необратимого действия вводом названия («как на GitHub»): случайный клик по «ОК»
 * ничего не удалит. Название сравнивается без учёта регистра и пробелов по краям.
 */
function ConfirmByNameModal({
  title,
  description,
  expectedName,
  confirmLabel = "Удалить",
  busy = false,
  error = "",
  onConfirm,
  onClose,
}) {
  const [typed, setTyped] = useState("");
  const matches = typed.trim() !== "" && typed.trim().toLowerCase() === String(expectedName || "").trim().toLowerCase();

  return (
    <Modal open onClose={busy ? () => {} : onClose} title={title}>
      <div>
        <div style={{ lineHeight: 1.5 }}>{description}</div>
        <label style={{ display: "grid", gap: 6, marginTop: 14 }}>
          <span>
            Чтобы подтвердить, введите название: <strong>{expectedName}</strong>
          </span>
          <input
            type="text"
            className="modal__input"
            value={typed}
            autoFocus
            autoComplete="off"
            onChange={(e) => setTyped(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter" && matches && !busy) { e.preventDefault(); onConfirm(typed.trim()); } }}
            placeholder={expectedName}
            disabled={busy}
          />
        </label>
        {error && <div role="alert" style={{ color: "var(--text-danger)", marginTop: 10 }}>{error}</div>}
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 }}>
          <button type="button" className="ghost" onClick={onClose} disabled={busy}>Отмена</button>
          <button type="button" className="ghost danger" disabled={!matches || busy} onClick={() => onConfirm(typed.trim())}>
            {busy ? "Удаляем…" : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmByNameModal;
